"use client"

import { useEffect } from "react";
import {useWindowSize} from "react-use";

export const useOutSideCkick = (ref, handler, attached = true) => {
    const { width } = useWindowSize();
    useEffect(() => {
        if (!attached) return;

        const handleClick = e => {
            if (!ref.current) return;
            if (!ref.current.contains(e.target) && width > 768) {
                handler()
            }
        }

        document.addEventListener('click', handleClick)
        return () => {
            document.removeEventListener('click', handleClick)
        }

    }, [ref, handler, attached])

}